// extracted by mini-css-extract-plugin
export default {"main":"Szukaj_main__9Cazl","icon_szukaj":"Szukaj_icon_szukaj__9DFDQ","icon_clear":"Szukaj_icon_clear__due7k","szukajInput":"Szukaj_szukajInput__TMlCG","icon2":"Szukaj_icon2__NUyoI"};